"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormFieldComponentsProvider = exports.FormFieldComponentsContext = exports.baseFormFieldComponentsDefinition = void 0;
var React = __importStar(require("react"));
var form_field_entity_select_1 = require("../elements/form-field-entity-select");
var form_field_hidden_1 = require("../elements/form-field-hidden");
var form_field_markdown_editor_1 = require("../elements/form-field-markdown-editor");
var form_field_color_picker_1 = require("../elements/form-field-color-picker");
var form_field_json_editor_1 = require("../elements/form-field-json-editor");
var form_field_date_range_1 = require("../elements/form-field-date-range");
var form_field_select_1 = require("../elements/form-field-select");
var form_field_datetime_range_1 = require("../elements/form-field-datetime-range");
var form_field_entity_reference_1 = require("../elements/form-field-entity-reference");
var form_field_checkbox_1 = require("../elements/form-field-checkbox");
var form_field_number_1 = require("../elements/form-field-number");
var form_field_date_1 = require("../elements/form-field-date");
var form_field_datetime_1 = require("../elements/form-field-datetime");
var form_field_file_1 = require("../elements/form-field-file");
var form_field_image_1 = require("../elements/form-field-image");
var form_field_text_1 = require("../elements/form-field-text");
var form_field_entity_table_1 = require("../elements/form-field-entity-table");
var create_inherited_provider_1 = require("../utils/create-inherited-provider");
// Defines the default set of entity field types to form field control mapping
// A key design choice for V2 is that we want to be able to use the form field components
// in more lightweight scenarios, V1's code ended up being very all or nothing.
exports.baseFormFieldComponentsDefinition = {
  id: form_field_hidden_1.FormFieldHidden,
  name: form_field_text_1.FormFieldText,
  nameHidden: form_field_hidden_1.FormFieldHidden,
  hidden: form_field_hidden_1.FormFieldHidden,
  description: form_field_markdown_editor_1.FormFieldMarkdownEditor,
  summary: form_field_markdown_editor_1.FormFieldMarkdownEditor,
  banner: form_field_entity_select_1.FormFieldEntitySelect,
  content: form_field_markdown_editor_1.FormFieldMarkdownEditor,
  color: form_field_color_picker_1.FormFieldColorPicker,
  json: form_field_json_editor_1.FormFieldJsonEditor,
  select: form_field_select_1.FormFieldSelect,
  dateRange: form_field_date_range_1.FormFieldDateRange,
  datetimeRange: form_field_datetime_range_1.FormFieldDatetimeRange,
  entityReference: form_field_entity_reference_1.FormFieldEntityReference,
  entityReferenceMultiple: form_field_entity_reference_1.FormFieldEntityReferenceMultiple,
  text: form_field_text_1.FormFieldText,
  textArea: form_field_text_1.FormFieldTextArea,
  longText: form_field_markdown_editor_1.FormFieldMarkdownEditor,
  boolean: form_field_checkbox_1.FormFieldCheckbox,
  int: form_field_number_1.FormFieldNumberInt,
  float: form_field_number_1.FormFieldNumber,
  date: form_field_date_1.FormFieldDate,
  datetime: form_field_datetime_1.FormFieldDatetime,
  visibility: form_field_hidden_1.FormFieldHidden,
  url: form_field_text_1.FormFieldText,
  email: form_field_text_1.FormFieldText,
  image: form_field_image_1.FormFieldImage,
  file: form_field_file_1.FormFieldFile,
  linked: form_field_entity_select_1.FormFieldEntitySelect,
  linkedMultiple: form_field_entity_select_1.FormFieldEntitySelectMultiple,
  parent: form_field_entity_select_1.FormFieldEntitySelect,
  linkedTable: form_field_entity_table_1.FormFieldEntityTable,
  permissions: form_field_entity_table_1.FormFieldEntityTable,
  grantedPerson: form_field_entity_select_1.FormFieldEntitySelect
};
exports.FormFieldComponentsContext = React.createContext(exports.baseFormFieldComponentsDefinition);
exports.FormFieldComponentsProvider = (0, create_inherited_provider_1.createInheritedProvider)(exports.FormFieldComponentsContext);